import { IFilter } from "@/api/AppApi/services/filters/interfaces/IGetFilters";
import ButtonOption from "../../common-filters-components/ButtonOption";
import {
  isSelected,
  toggleOption,
} from "../../common-filters-components/toggleOption";
import TabsSlider from "@/app/components/lib/Embla-tabs-slider/TabsSlider";
import { IsTopWinner } from "@/utils/functions/global-constants";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";

interface Props {
  filter: IFilter;
  state: string[];
  setState: (state: string[]) => void;
  unAvailabeKeys?: string[];
  isFilterDrawer?: boolean;
  outOfStockKeys?: string[];
  isProductBox?: boolean;
}
const SelectButtons: React.FC<Props> = ({
  filter,
  state,
  setState,
  unAvailabeKeys = [],
  isFilterDrawer = false,
  outOfStockKeys,
  isProductBox,
}) => {
  const company = useGetCompanyQuery();
  const isTopWinner = IsTopWinner(company?.data?.result!);
  let options = filter?.data ?? [];
  const is_multi_select = filter?.configurations?.is_multi_select;
  return (
    <div
      style={{
        width: `${isFilterDrawer ? 274 : "auto"}`,
      }}
    >
      <TabsSlider
        spacing={8}
        className={`${isTopWinner ? "select-btn-slider" : " "}`}
        selectedIndex={options.findIndex((op) => isSelected(state, op.key))}
      >
        {options
          ?.filter((op) => !isSelected(unAvailabeKeys, op.key))
          ?.map((option) => (
            <ButtonOption
              isTopWinner={isTopWinner}
              key={option.key}
              text={option.value}
              disabled={
                isSelected(unAvailabeKeys, option.key) ||
                isSelected(outOfStockKeys, option.key)
              }
              selected={isSelected(state, option.key)}
              toggleOption={() =>
                setState(toggleOption(state, option.key, is_multi_select))
              }
              isProductBox={isProductBox}
            />
          ))}
      </TabsSlider>
    </div>
  );
};
export default SelectButtons;
